"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Score {
    // eslint-disable-next-line no-useless-constructor
    constructor(score, type) {
        this.type = type || '';
        this.value = this.polishScore(score) || 0;
    }
    polishScore(s) {
        const notRoundKeys = ['rate', 'phch'];
        if (notRoundKeys.includes(this.type)) {
            return s;
        }
        else {
            if (s < 1 && s > 0)
                return 1;
            return Math.round(s);
        }
    }
}
exports.default = Score;
